var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.09449 60.09449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.14633,
    y: 9.12141,
    width: 43.86898,
    height: 43.86898,
    rx: 10.01575,
    ry: 10.01575,
    transform: "translate(-13.14937 30.36641) rotate(-45)",
    strokeWidth: 0,
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.72245,
    y: 8.3939,
    width: 40.66394,
    height: 40.66394,
    rx: 10.01575,
    ry: 10.01575,
    transform: "translate(-11.50952 29.66529) rotate(-45)",
    strokeWidth: 0,
    fill: "#f59e00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.61243,18.38166l-.27502-.40778h-6.66022c.01135-.0885.02704-.17578.02704-.26733,0-1.16736-.94971-2.117-2.117-2.117h-3.25134c-1.16736,0-2.117.94965-2.117,2.117,0,.09155.01569.17883.02704.26733h-6.18658l-.27454.4118c-.05286.07904-1.29517,1.95306-1.80591,3.62439-.28357.92889.0578,1.50824.28632,1.77063.38251.43933.94556.60132,1.43988.65143l1.40509,16.7298c.13861,1.15149.99884,3.32855,3.25903,3.32855h11.73151c.08447.00952.17297.01447.26465.01447.96771,0,2.27325-.56445,2.64941-2.26782.36139-1.63684,1.42596-14.6217,1.69977-18.01288.47034-.18396.92798-.49243,1.25128-.99176.81689-1.26215-.49719-3.58099-1.35339-4.85083ZM28.06854,17.70655c0-.14722.12012-.26733.26733-.26733h3.25134c.14722,0,.26733.12012.26733.26733s-.12012.26733-.26733.26733h-3.25134c-.14722,0-.26733-.12012-.26733-.26733ZM37.20844,41.83796c-.16254.73743-.59021.84894-.90808.81329l-11.93115-.01044c-1.18536,0-1.41437-1.63556-1.41931-1.66675l-1.38995-16.5553h17.2832c-.4231,5.21124-1.3457,16.11188-1.6347,17.41919ZM19.74268,22.5691c.00159-.00623.0033-.01239.00549-.01892.30255-.98987.95239-2.13055,1.31592-2.72662h18.27673c.61279.99792,1.07697,2.07184,1.04266,2.44525-.13586.17487-.3587.25848-.56476.30029h-20.07605Z",
    strokeWidth: 0,
    fill: "#82368c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1895,41.138c-.36397,0-.66924-.28314-.69182-.65118l-.91038-14.78285c-.02348-.38203.26733-.71123.64982-.73472.39061-.02393.71123.26733.73472.64982l.91038,14.78285c.02348.38203-.26733.71123-.64982.73472-.01445.0009-.0289.00135-.0429.00136Z",
    strokeWidth: 0,
    fill: "#82368c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.19996,41.138c-.38294,0-.69362-.31069-.69362-.69362v-14.78285c0-.38294.31069-.69362.69362-.69362s.69362.31069.69362.69362v14.78285c0,.38294-.31069.69362-.69362.69362Z",
    strokeWidth: 0,
    fill: "#82368c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.34048,41.138c-.014,0-.02845-.00045-.0429-.00135-.38249-.02348-.6733-.35268-.64982-.73472l.91038-14.78285c.02348-.38203.34771-.66834.73472-.64982.38249.02348.6733.35268.64982.73472l-.91038,14.78285c-.02258.36804-.32785.65118-.69182.65117Z",
    strokeWidth: 0,
    fill: "#82368c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUpIcon);
export default __webpack_public_path__ + "static/media/DeleteUpIcon.b656165439f9e6287f18b2a7b14dc148.svg";
export { ForwardRef as ReactComponent };